<template>
  <v-container>
    <div style="width: 100%" class="d-flex justify-space-between">
      <div
        class="d-flex justify-space-between align-start"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'flex-column'"
      >
        <div
          :style="
            $vuetify.breakpoint.mdAndUp
              ? 'min-width: 400px; max-width: 800px'
              : 'width:100%'
          "
        >
          <v-text-field
            dense
            label="Traži"
            v-model="search"
            outlined
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </div>
      </div>
      <v-btn
        v-show="hasAdminRights && getDeviceType != 'touch'"
        @click="foreignModal = true"
        color="primary"
      >
        Dodaj autora</v-btn
      >
      <v-btn
        v-show="hasAdminRights && getDeviceType === 'touch'"
        @click="foreignModal = true"
        fab
        elevation="0"
        color="primary"
        x-small
      >
        <v-icon>mdi-plus</v-icon></v-btn
      >
    </div>
    <v-data-table
      :loading="$wait.is('getInitialData')"
      :headers="headers"
      :items="getStraniAutori.data"
      hide-default-footer
      :items-per-page="getStraniAutori.per_page"
      class="elevation-1 curs"
      no-data-text="Nema podataka"
      no-results-text="Nema podataka"
    >
      <template v-slot:[`item.sifra`]="{ item }">
        <span v-if="item.sifra">{{ item.sifra }}</span>
        <span v-else>-</span>
      </template>
      <template v-slot:[`item.organizacija`]="{ item }">
        <span v-if="item.organizacija">{{ item.organizacija }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="goToDetails(item)"
              v-bind="attrs"
              color="primary"
              v-on="on"
            >
              mdi-information
            </v-icon>
          </template>
          <span>Detaljan pregled</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="hasAdminRights"
              @click="editForeignAuthor(item)"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              color="primary"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Uredi</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="hasAdminRights"
              @click="deleteItem(item)"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              color="red"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Izbriši</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        total-visible="20"
        @input="goTo"
        :length="getStraniAutori.last_page"
      ></v-pagination>
    </div>

    <v-dialog
      v-model="foreignModal"
      :fullscreen="!$vuetify.breakpoint.mdAndUp"
      max-width="600px"
      style="overflow-x: hidden"
    >
      <v-card>
        <v-card-title style="background-color: rgb(8, 71, 118)">
          <h3 style="color: white" v-show="!isInEdit">Novi strani autor</h3>
          <h3 style="color: white" v-show="isInEdit">
            Uređivanje stranog autora
          </h3>
          <v-spacer></v-spacer>
          <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
        <v-form ref="form" v-model="valid">
          <v-row
            class="ml-6 mr-6 mt-8 d-flex align-center justify-center"
            no-gutters
          >
            <v-col :cols="getDeviceType === 'touch' ? 12 : 12" no-gutters>
              <v-text-field
                no-gutters
                v-model="name"
                label="Unesi ime*"
                required
                dense
                outlined
                :rules="[rules.nameRules]"
              ></v-text-field>
            </v-col>
            <v-col :cols="getDeviceType === 'touch' ? 12 : 12" no-gutters>
              <v-text-field
                no-gutters
                v-model="surname"
                label="Unesi prezime*"
                required
                dense
                outlined
                :rules="[rules.surnameRules]"
              ></v-text-field>
            </v-col>
            <v-col :cols="getDeviceType === 'touch' ? 12 : 6" class="pb-1">
              <v-autocomplete
                v-model="akadStupanj"
                :class="$vuetify.breakpoint.mdAndUp ? 'mr-4' : ''"
                :items="getAkademskiStupnjevi"
                dense
                label="Odaberi akademski stupanj"
                item-text="naziv"
                return-object
                outlined
                :search-input.sync="searchInputStupanj"
              ></v-autocomplete>
            </v-col>
            <v-col :cols="getDeviceType === 'touch' ? 12 : 6" class="pb-1">
              <v-autocomplete
                v-model="title"
                :items="getZvanja"
                dense
                label="Odaberi zvanje"
                outlined
                item-text="naziv"
                return-object
                :search-input.sync="searchInputTitula"
              ></v-autocomplete>
            </v-col>
            <v-col :cols="getDeviceType === 'touch' ? 12 : 12" class="pb-1">
              <v-text-field
                v-model="organizacija"
                label="Unesi organizaciju*"
                required
                dense
                outlined
                :rules="[rules.orgRules]"
              ></v-text-field>
            </v-col>
            <v-col :cols="getDeviceType === 'touch' ? 12 : 12" class="pb-1">
              <v-text-field
                v-model="sifra"
                label="Unesi šifru*"
                required
                outlined
                dense
                :rules="[rules.passwordRules]"
              ></v-text-field>
            </v-col>
            <!-- <hint
              v-if="!inEdit"
              :hints="getBazaHints"
              :isSelectable="isSelectable"
              v-on:selectItem="selectBazu"
            ></hint> -->
            <v-col cols="12" class="d-flex justify-end" v-if="hasAdminRights">
              <v-btn
                v-show="!isInEdit"
                class="mx-1 mb-6"
                :disabled="!isValid"
                color="rgb(8, 71, 118)"
                style="color: white"
                @click="addStraniAutor"
              >
                Dodaj autora
              </v-btn>
              <v-btn
                v-show="isInEdit"
                class="mx-1 mb-6"
                :disabled="!isValid"
                color="rgb(8, 71, 118)"
                style="color: white"
                @click="addStraniAutor"
              >
                Spremi promjene
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      persistent
      no-click-animation
      max-width="290"
    >
      <v-card :loading="$wait.is('deleteForeignAuthor')">
        <v-card-title class="headline">Izbriši autora</v-card-title>
        <v-card-text>Da li ste sigurni da želite izbrisati autora?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            :disabled="$wait.is('deleteForeignAuthor')"
            text
            @click="deleteDialog = false"
            >Ne</v-btn
          >
          <v-btn
            color="red darken-1"
            :disabled="$wait.is('deleteForeignAuthor')"
            text
            @click="Delete"
            >Izbriši</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openDetails" fullscreen>
      <v-toolbar color="rgb(8, 71, 118)" v-if="selectedStraniAutor">
        <v-icon @click="closeDetails" class="mr-2 ml-0" color="white" left
          >mdi-close</v-icon
        >
        <h4 style="color: white">
          {{ selectedStraniAutor.ime }} {{ selectedStraniAutor.prezime }}
        </h4>
      </v-toolbar>
      <detalji-strani-autor 
    class="pa-12 pt-0"
        :selectedStraniAutor="selectedStraniAutor"
      ></detalji-strani-autor>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "lodash";
import { waitFor } from "vue-wait";
import { mapGetters } from "vuex";
export default {
  name: "StraniAutori",
  // metaInfo: {
  //     title: 'Strani autori - Registar radova'
  //   },
  data: () => ({
    rules: {
      nameRules: (v) => !!v || "Ime je obavezno!",
      surnameRules: (v) => !!v || "Prezime je obavezno!",
      orgRules: (v) => !!v || "Organizacija je obavezna!",
      passwordRules: (v) => !!v || "Šifra je obavezna!",
    },
    title: "",
    name: "",
    surname: "",
    akadStupanj: "",
    organizacija: "",
    sifra: "",
    dialog: false,
    searchMembers: "",
    searchTitula: "",
    searchStupanj: "",
    headers: [
      {
        text: "Ime",
        align: "start",
        sortable: false,
        value: "ime",
      },
      {
        text: "Prezime",
        align: "start",
        sortable: false,
        value: "prezime",
      },
      { text: "Organizacija", value: "organizacija", sortable: false },
      { text: "Šifra", value: "sifra", sortable: false },
      { text: "", value: "actions", sortable: false, align: "end" },
    ],
    page: 1,
    foreignModal: false,
    isInEdit: false,
    selectedAuthor: {},
    selectedForDelete: {},
    deleteDialog: false,
    selectedStraniAutor: null,
    openDetails: false,
    valid: true,
    comaprationQuerry: "?page=1",
  }),

  computed: {
    ...mapGetters([
      "getStraniAutori",
      "getAkademskiStupnjevi",
      "getZvanja",
      "hasAdminRights",
      "getDeviceType",
    ]),
    isValid() {
      return (
        this.name != "" &&
        this.surname != "" &&
        this.organizacija != "" &&
        this.sifra != "" &&
        this.name != null &&
        this.surname != null &&
        this.organizacija != null &&
        this.sifra != null
      );
    },
    search: {
      set(value) {
        if (value != this.searchMembers) {
          this.searchMembers = value;
          waitFor("getInitialData", async function () {
            await this.$store.dispatch("getStraniAutori", {
              page: 1,
              search: this.searchMembers,
            });
          }).apply(this);
        }
      },
      get() {
        return this.searchMembers;
      },
    },
    searchInputTitula: {
      set(value) {
        if (value != this.searchTitula) {
          this.searchTitula = value;
          this.$store.dispatch("getZvanja", value);
        }
      },
      get() {
        return "";
      },
    },
    searchInputStupanj: {
      set(value) {
        if (value != this.searchStupanj) {
          this.searchStupanj = value;
          this.$store.dispatch("getAkademskiStupnjevi", value);
        }
      },
      get() {
        return "";
      },
    },
  },
  // watch: {
  //   title(newVal, oldVal) {
  //     if (newVal != oldVal) {
  //       this.comaprationQuerry =
  //         this.comaprationQuerry + "&filter[title]=~=" + newVal;
  //       this.getHint(this, this.comparationQuerry);
  //     }
  //   },
  //   name(newVal, oldVal) {
  //     console.log(newVal, this.comaprationQuerry);

  //     if (newVal != oldVal) {
  //       this.comaprationQuerry =
  //         this.comaprationQuerry + "&filter[ime]=~=" + newVal;
  //       this.getHint(this, this.comparationQuerry);
  //     }
  //   },
  //   surname(newVal, oldVal) {
  //     if (newVal != oldVal) {
  //       this.comaprationQuerry =
  //         this.comaprationQuerry + "&filter[]=~=" + newVal;
  //       this.getHint(this, this.comparationQuerry);
  //     }
  //   },
  //   akadStupanj(newVal, oldVal) {
  //     if (newVal != oldVal) {
  //       this.comaprationQuerry =
  //         this.comaprationQuerry + "&filter[]=~=" + newVal;
  //       this.getHint(this, this.comparationQuerry);
  //     }
  //   },
  //   organizacija(newVal, oldVal) {
  //     if (newVal != oldVal) {
  //       this.comaprationQuerry =
  //         this.comaprationQuerry + "&filter[]=~=" + newVal;
  //       this.getHint(this, this.comparationQuerry);
  //     }
  //   },
  //   sifra(newVal, oldVal) {
  //     if (newVal != oldVal) {
  //       this.comaprationQuerry =
  //         this.comaprationQuerry + "&filter[]=~=" + newVal;
  //       console.log(this.comparationQuerry);
  //       this.getHint(this, this.comparationQuerry);
  //     }
  //   },
  // },
  methods: {
    goToDetails(autor) {
      this.selectedStraniAutor = autor;
      waitFor("getStraniAutorDetails", async function () {
        await this.$store.dispatch("fetchStraniAutor", autor.id);
      }).apply(this);

      this.openDetails = true;
    },
    getHint: _.debounce((self, value) => {
      console.log(self.comaprationQuerry)
      waitFor("getAuthorsHint", async function () {
        await self.$store.dispatch("getAuthorsHint", value);
      }).apply(self);
    }, 500),
    async closeDetails() {
      this.openDetails = false;
    },
    deleteItem(item) {
      this.selectedForDelete = item;
      this.deleteDialog = true;
    },
    async Delete() {
      waitFor("deleteForeignAuthor", async function () {
        await this.$store
          .dispatch("deleteForeignAuthor", this.selectedForDelete.id)
          .then(() => {
            this.selectedForDelete = {};
            this.deleteDialog = false;
            this.$store.dispatch("getStraniAutori", {
              page: 1,
              search: this.searchMembers,
            });
          });
      }).apply(this);
    },
    editForeignAuthor(author) {
      this.selectedAuthor = author;
      this.name = author.ime;
      this.surname = author.prezime;
      this.title = this.getZvanja.find((a) => a.id == author.zvanje_id);
      this.akadStupanj = this.getAkademskiStupnjevi.find(
        (a) => a.id == author.akad_stupanj_id
      );
      this.organizacija = author.organizacija;
      this.sifra = author.sifra;
      this.foreignModal = true;
      this.isInEdit = true;
    },
    closeDialog() {
      this.name = "";
      this.surname = "";
      this.title = "";
      this.akadStupanj = "";
      this.organizacija = "";
      this.sifra = "";
      this.isInEdit = false;
      this.foreignModal = false;
      this.$refs.form.reset();
    },
    goTo(item) {
      this.page = item;
      waitFor("getInitialData", async function () {
        await this.$store.dispatch("getStraniAutori", {
          page: item,
          search: this.searchMembers,
        });
      }).apply(this);
    },
    addStraniAutor() {
      let noviStraniAutor = {
        ime: this.name,
        prezime: this.surname,
        organizacija: this.organizacija,
        sifra: this.sifra,
      };
      if (this.title) {
        Object.assign(noviStraniAutor, { zvanje_id: this.title.id });
      }
      if (this.akadStupanj) {
        Object.assign(noviStraniAutor, {
          akad_stupanj_id: this.akadStupanj.id,
        });
      }
      if (this.isInEdit) {
        Object.assign(noviStraniAutor, { id: this.selectedAuthor.id });
        this.$store
          .dispatch("editStraniAuthor", noviStraniAutor)
          .then((res) => {
            Object.assign(res, { punoIme: res.ime + " " + res.prezime });
            // this.odabraniAutori.push(res)
            this.name = "";
            this.surname = "";
            this.title = "";
            this.akadStupanj = "";
            this.organizacija = "";
            this.sifra = "";
            this.isInEdit = false;
            this.foreignModal = false;
            this.$refs.form.reset();
            this.$store.dispatch("getStraniAutori", {
              page: 1,
              search: this.searchMembers,
            });
          });
      } else {
        this.$store
          .dispatch("createNewStraniAutor", noviStraniAutor)
          .then((res) => {
            Object.assign(res, { punoIme: res.ime + " " + res.prezime });
            // this.odabraniAutori.push(res)
            this.name = "";
            this.surname = "";
            this.title = "";
            this.akadStupanj = "";
            this.organizacija = "";
            this.sifra = "";
            this.isInEdit = false;
            this.foreignModal = false;
            this.$refs.form.reset();
          });
      }
    },
  },
  beforeCreate() {
    waitFor("getInitialData", async function () {
      await this.$store.dispatch("getStraniAutori", { page: 1, search: "" });
      await this.$store.dispatch("getZvanja", "");
      await this.$store.dispatch("getAkademskiStupnjevi", "");
    }).apply(this);
  },
};
</script>

<style lang="scss">
.curs > .v-data-table__wrapper > table tbody td {
  cursor: context-menu !important;
}
</style>